import { render, staticRenderFns } from "./Months.vue?vue&type=template&id=094c4db2&lang=pug&"
import script from "./Months.vue?vue&type=script&lang=ts&"
export * from "./Months.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports